<template>
  <div id="app">
    <notifications
      position="bottom center"
      classes="notification"
      width="300px"
    />
    <router-view />
  </div>
</template>

<script>
import { EventBus } from "./main";

export default {
  name: "App",
  components: {},
  mounted() {
    EventBus.$on("systemNotification", function (message) {
      this.$notify({
        text: message,
      });
    });
  },
};
</script>

<style>
#app {
  font-family: "Roboto", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* color: #2c3e50; */
  /* background-color: #fffefc; */
  /* margin-top: 60px; */
}
.notification {
  z-index: 1;
}
.notification .notification-content {
  border-color: #161616;
  border: 0;
  text-align: center;
  border-radius: 50px;
  font-weight: 500;
  margin-bottom: 20px;
  padding: 9px 25px;
  font-size: 14px;
  color: #ffffff;
  background-color: #161616;
}
</style>
